import React, { useEffect, useMemo, useState } from "react";
import { Modal, Table, Button, Form, Row, Col, Pagination } from "react-bootstrap";
import { getFacturasChequePendientes } from "../../../Api/ChequesApi";

/* ===================== HELPERS ===================== */
const formatMiles = (n) =>
  Number(n || 0).toLocaleString("es-PY");

const ITEMS_PER_PAGE = 8;

const ProfesionalChequeModal = ({ show, onHide, onSelect }) => {
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState("");
  const [page, setPage] = useState(1);

  /* ===================== DATA ===================== */
  useEffect(() => {
    if (show) {
      getFacturasChequePendientes().then((data) => {
        setRows(data || []);
        setPage(1);
      });
    }
  }, [show]);

  /* ===================== FILTER ===================== */
  const filteredRows = useMemo(() => {
    if (!filter) return rows;

    const f = filter.toLowerCase();

    return rows.filter((r) =>
      [
        r.Nombre,
        r.numerofactura,
        r.idliquidacion,
        r.idordendepago,
      ]
        .join(" ")
        .toLowerCase()
        .includes(f)
    );
  }, [rows, filter]);

  /* ===================== PAGINATION ===================== */
  const totalPages = Math.ceil(filteredRows.length / ITEMS_PER_PAGE);

  const paginatedRows = useMemo(() => {
    const start = (page - 1) * ITEMS_PER_PAGE;
    return filteredRows.slice(start, start + ITEMS_PER_PAGE);
  }, [filteredRows, page]);

  const renderPagination = () => {
    if (totalPages <= 1) return null;

    return (
      <Pagination className="justify-content-center">
        <Pagination.Prev
          disabled={page === 1}
          onClick={() => setPage((p) => p - 1)}
        />
        {[...Array(totalPages)].map((_, i) => (
          <Pagination.Item
            key={i + 1}
            active={page === i + 1}
            onClick={() => setPage(i + 1)}
          >
            {i + 1}
          </Pagination.Item>
        ))}
        <Pagination.Next
          disabled={page === totalPages}
          onClick={() => setPage((p) => p + 1)}
        />
      </Pagination>
    );
  };

  /* ===================== RENDER ===================== */
  return (
    <Modal show={show} onHide={onHide} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Profesionales (Cheque)</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* FILTRO */}
        <Row className="mb-3">
          <Col md={6}>
            <Form.Control
              placeholder="Filtrar por profesional, factura, liquidación u orden de pago"
              value={filter}
              onChange={(e) => {
                setFilter(e.target.value);
                setPage(1);
              }}
            />
          </Col>
        </Row>

        {/* TABLA */}
        <Table size="sm">
          <thead className="table-dark">
            <tr>
              <th>Profesional</th>
              <th>Factura</th>
              <th>ID Liquidación</th>
              <th>ID Orden Pago</th>
              <th className="text-end">Monto</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {paginatedRows.length === 0 && (
              <tr>
                <td colSpan={6} className="text-center text-muted">
                  Sin resultados
                </td>
              </tr>
            )}

            {paginatedRows.map((r) => (
              <tr key={r.idfacturasprofesionales}>
                <td>{r.Nombre}</td>
                <td>{r.numerofactura}</td>
                <td>{r.idliquidacion || "-"}</td>
                <td>{r.idordendepago || "-"}</td>
                <td className="text-end fw-bold">
                  {formatMiles(r.monto)}
                </td>
                <td className="text-center">
                  <Button size="sm" onClick={() => onSelect(r)}>
                    Usar
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

        {/* PAGINACIÓN */}
        {renderPagination()}
      </Modal.Body>
    </Modal>
  );
};

export default ProfesionalChequeModal;
